import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CustomSelect from '../../../../components/CustomSelect/CustomSelect';
import { RootState } from '../../../../store/store';
import {
  getTeamQOverviewData,
  getTeamQActivityData,
  getTeamQAnalyticsData,
  initialRequestWasSent,
} from '../../../../store/teamQ/teamQ.actions';
import { getTeams } from '../../../../store/teams/teams.actions';

export const TeamQDateAndTeamSelectors: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const { teams } = useSelector((state: RootState) => state.teams);

  const {
    initialReqestWasSent,
    activity,
    upperHand,
    estTendencies,
    sellingZone,
    threadDuration,
    threadLength,
    analyzed,
    simulated,
    analyticsUpperHand,
    analyticsSellZone,
    competence,
    empathy,
    responsiveness,
  } = useSelector((state: RootState) => state.teamQ);

  const { pathname } = useLocation();

  const dispatch = useDispatch();

  const [datesArray, setDatesArray] = useState<any>([]); // eslint-disable-line

  const [teamsArray, setTeamsArray] = useState<any>([]); // eslint-disable-line

  const [choosedTimePeriod, setChoosedTimePeriod] = useState<{
    label?: string;
    from: string;
    to: string;
  } | null>(null);

  const [choosedTeam, setChoosedTeam] = useState('');

  useEffect(() => {
    if (!datesArray.length) {
      const generateDatesArray = () => {
        const today = moment().format('YYYY-MM-DD');
        const ninetyDays = moment().subtract(90, 'days').format('YYYY-MM-DD');
        const thirtyDays = moment().subtract(30, 'days').format('YYYY-MM-DD');
        const sevenDays = moment().subtract(7, 'days').format('YYYY-MM-DD');
        const arr = [
          { label: 'Last 7 days', from: sevenDays, to: today },
          { label: 'Last 30 days', from: thirtyDays, to: today },
          { label: 'Last 90 days', from: ninetyDays, to: today },
        ];

        return arr;
      };

      setDatesArray(generateDatesArray());
      setChoosedTimePeriod(generateDatesArray()[2]);
    }

    if (user && !teams.length) {
      dispatch(getTeams(user.orgId));
    }

    if (pathname.includes('team-analytics')) {
      const generateTeamsArray = () => {
        const allUsers = [{ label: 'All Users', teamId: 'allUsers' }];

        const allTeams = teams?.map((el) => ({
          label: el.name,
          teamId: el.teamId,
        }));

        const resultArr = allTeams.length
          ? allTeams.concat(allUsers)
          : allUsers;

        return resultArr;
      };

      setTeamsArray(generateTeamsArray());

      if (generateTeamsArray()?.length) {
        const generatedTeamArr = generateTeamsArray();

        setChoosedTeam(generatedTeamArr[generatedTeamArr.length - 1].teamId);
      }
    }
  }, [user, teams.length]); // eslint-disable-line

  useEffect(() => {
    if (user) {
      if (choosedTeam && choosedTimePeriod) {
        const fromDate = choosedTimePeriod.from;

        const toDate = choosedTimePeriod.to;

        const teamId = choosedTeam.length ? choosedTeam : '';

        const checkTimePeriod = moment.duration(
          moment(toDate).diff(moment(fromDate))
        );

        const timePeriodInDays = checkTimePeriod.asDays()
          ? +checkTimePeriod.asDays().toFixed(0)
          : 0;

        if (pathname.includes('team-analytics')) {
          if (pathname.includes('overview')) {
            dispatch(
              getTeamQOverviewData(
                user.orgId,
                user.userId,
                fromDate,
                toDate,
                teamId,
                timePeriodInDays,
                true
              )
            );
          } else if (pathname.includes('activity')) {
            dispatch(
              getTeamQActivityData(
                user.orgId,
                user.userId,
                fromDate,
                toDate,
                teamId,
                timePeriodInDays,
                true
              )
            );
          } else if (pathname.includes('team-analytics/analytics')) {
            dispatch(
              getTeamQAnalyticsData(
                user.orgId,
                user.userId,
                fromDate,
                toDate,
                teamId,
                timePeriodInDays,
                true
              )
            );
          }

          setTimeout(() => {
            dispatch(initialRequestWasSent());
          }, 1000);
        }
      }
    }
  }, [choosedTeam, choosedTimePeriod, user]); // eslint-disable-line

  useEffect(() => {
    if (user && initialReqestWasSent) {
      const overviewNoDataCheck =
        !activity && !upperHand && !estTendencies && !sellingZone;

      const activityNoDataCheck =
        !threadDuration && !threadLength && !analyzed && !simulated;

      const analyticsNoDataCheck =
        !analyticsUpperHand &&
        !analyticsSellZone &&
        !competence &&
        !empathy &&
        !responsiveness;

      if (choosedTeam && choosedTimePeriod) {
        const fromDate = choosedTimePeriod.from;

        const toDate = choosedTimePeriod.to;

        const teamId = choosedTeam.length ? choosedTeam : '';

        const checkTimePeriod = moment.duration(
          moment(toDate).diff(moment(fromDate))
        );

        const timePeriodInDays = checkTimePeriod.asDays()
          ? +checkTimePeriod.asDays().toFixed(0)
          : 0;

        if (pathname.includes('team-analytics')) {
          if (pathname.includes('overview') && overviewNoDataCheck) {
            dispatch(
              getTeamQOverviewData(
                user.orgId,
                user.userId,
                fromDate,
                toDate,
                teamId,
                timePeriodInDays
              )
            );
          } else if (pathname.includes('activity') && activityNoDataCheck) {
            dispatch(
              getTeamQActivityData(
                user.orgId,
                user.userId,
                fromDate,
                toDate,
                teamId,
                timePeriodInDays
              )
            );
          } else if (
            pathname.includes('team-analytics/analytics') &&
            analyticsNoDataCheck
          ) {
            dispatch(
              getTeamQAnalyticsData(
                user.orgId,
                user.userId,
                fromDate,
                toDate,
                teamId,
                timePeriodInDays
              )
            );
          }
        }
      }
    } // eslint-disable-next-line
  }, [pathname]);

  const chooseTeam = (arr: typeof teamsArray) => {
    const { teamId } = arr;

    if (teamId) {
      setChoosedTeam(teamId);
    }
  };

  const chooseTimePeriod = (arr: typeof datesArray) => {
    const fromDate = arr.from;

    const toDate = arr.to;

    if (fromDate && toDate) {
      setChoosedTimePeriod({ from: fromDate, to: toDate });
    }
  };

  const attrs = {
    wrapper: {
      className: 'teamq-date-and-team-selector',
    },

    teamSelector: {
      items: teamsArray,
      selectedItem: teamsArray[teamsArray?.length - 1 || 0],
      onChange: chooseTeam,
      isTeamQ: true,
    },

    dateSelector: {
      items: datesArray,
      selectedItem: datesArray[2],
      onChange: chooseTimePeriod,
      isTeamQ: true,
    },
  };

  return (
    <div {...attrs.wrapper}>
      <CustomSelect {...attrs.teamSelector} />
      <CustomSelect {...attrs.dateSelector} />
    </div>
  );
};
